import SiteLayout from '@/components/feature/SiteLayout';
import { useSeo } from '@/hooks/useSeo';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import PlotIntro from '@/pages/home/components/PlotIntro';
import LatestEpisodes from '@/pages/home/components/LatestEpisodes';
import RecommendSection from '@/pages/home/components/RecommendSection';

export default function Home() {
  useSeo({
    title: '无颜之月在线观看 - 高清正版电视剧在线播放平台',
    description:
      '无颜之月在线观看为您提供无颜之月电视剧及相关影视内容，涵盖剧情介绍、剧集更新，方便用户在线观看和了解剧情走势。',
    keywords: '无颜之月在线观看,无颜之月电视剧,无颜之月剧情,在线观看无颜之月,影视剧在线',
    path: '/',
  });

  return (
    <SiteLayout transparentNav>
      <HeroCarousel />
      <PlotIntro />
      <LatestEpisodes />
      <RecommendSection />
    </SiteLayout>
  );
}